module.exports = __webpack_public_path__ + "static/media/error-icon.ca3d06f4.svg";